// ResetPassword.js
import React, { useState, useEffect } from "react";
import { Box, Button, Form, FormField, Heading, Text, TextInput } from "grommet";
import { auth } from "./firebase";
import { sendPasswordResetEmail } from "firebase/auth";
import { useNavigate, useLocation  } from "react-router-dom";
import { Trash } from 'grommet-icons';

const ResetPassword = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.state?.email) {
            setEmail(location.state.email);
        }
    }, [location.state]);

    const handleReset = async ({ value }) => {
        const email = value.email.trim();
        setMessage("");
        setError("");

        try {
            await sendPasswordResetEmail(auth, email);
            setMessage("A password reset link has been sent to your email.");
        } catch (err) {
            setError(err.message);
        }
    };

    const handleCancel = () => {
        navigate("/login"); // Redirect to login page
    };

    const handleClear = () => {
        setEmail("");
    };

  return (
    <Box
      fill
      align="center"
      justify="center"
      background="light-1"
      pad="large"
    >
      <Box width="medium" background="white" elevation="medium" round="small" pad="medium">
        <Heading level={3} margin={{ bottom: "small" }}>
          Reset Password
        </Heading>

        {message && (
          <Box margin={{ vertical: "small" }}>
            <Text color="status-ok">{message}</Text>
          </Box>
        )}

        {error && (
            <Box margin={{ vertical: "small" }}>
                <Text color="status-critical">{error}</Text>
            </Box>
        )}

        <Form onSubmit={handleReset}>
            <Box margin={{ vertical: "small" }}>
                <Text >Email</Text>
            </Box>
            <FormField name="email" required >
                <Box direction="row" align="center" gap="small">
                <TextInput
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                />
                {email && (
                    <Button
                        icon={<Trash size="16px" />}
                        onClick={handleClear}
                        plain
                        hoverIndicator
                    />
                )}
                </Box> 
            </FormField>

            <Box direction="row" gap="small" justify="end" margin={{ top: "medium" }}>
                <Button type="button" label="Cancel" onClick={handleCancel} secondary />
                <Button type="submit" label="Send Reset Link" primary />
            </Box>

        </Form>
      </Box>
    </Box>
  );
};

export default ResetPassword;